import { lazy } from 'react';

const Rebates = lazy(() => import('../../admin/rebates/AdminRebatesPage'));

const ManagerRebatesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/rebates',
      element: <Rebates />,
    },
  ],
};

export default ManagerRebatesConfig;
